import React from 'react';
import PropTypes from 'prop-types';
import FaqBlock from 'ggApp/shared/common/Faq/Block';
import { BlockHeading } from 'ggApp/shared/screens/PartnerProductPage/Common';
import { Wrapper } from './styled';

const Faq = ({ content, title }) => {
    if (!content.length) {
        return null;
    }
    return (
        <Wrapper>
            <FaqBlock sectionTitle={<BlockHeading>{title}</BlockHeading>} content={content} />
        </Wrapper>
    );
};

Faq.propTypes = {
    content: PropTypes.arrayOf(PropTypes.object).isRequired,
    title: PropTypes.string.isRequired,
};

export default Faq;
